import useTranslation from 'next-translate/useTranslation';
import { Flex, Text } from '@eqi-investimentos/react';
export const DisclaimerResearchContent = () => {
  const {
    t
  } = useTranslation('common');
  return <Flex flexDir="column" w="full" gap="l" p="2xl" pt="0" data-sentry-element="Flex" data-sentry-component="DisclaimerResearchContent" data-sentry-source-file="DisclaimerResearchContent.tsx">
      <Text size="2xl" color="content.primary" data-sentry-element="Text" data-sentry-source-file="DisclaimerResearchContent.tsx">
        {t('app.disclaimerEqiResearchHubContentTitle')}
      </Text>
      <Text size="s" color="content.secondary" data-sentry-element="Text" data-sentry-source-file="DisclaimerResearchContent.tsx">
        {t('app.disclaimerEqiResearchHubContent')}
      </Text>
    </Flex>;
};